<template>
  <!-- Same container structure as your table -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Form with table-like width -->
      <form class="min-w-full divide-y divide-gray-200">
        <!-- Form Header -->
        <div class="mb-6">
          <h2 class="text-lg font-medium text-gray-900">Create New RFI</h2>
          <p class="mt-1 text-sm text-gray-500">Fill in all required details</p>
        </div>

        <!-- Fields from your table headers -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Subject -->
          <div>
            <label
              for="subject"
              class="block text-sm font-medium text-gray-700"
            >
              Subject <span class="text-brand-700">*</span>
            </label>
            <input
              type="text"
              id="subject"
              v-model="form.subject"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              placeholder="e.g., Pipe Material Clarification"
              required
            />
          </div>

          <!-- Requestor -->
          <div>
            <label
              for="requestor"
              class="block text-sm font-medium text-gray-700"
            >
              Requestor <span class="text-brand-700">*</span>
            </label>
            <input
              type="text"
              id="requestor"
              v-model="form.requestor"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              placeholder="Name"
              required
            />
          </div>

          <!-- Priority -->
          <div>
            <label
              for="priority"
              class="block text-sm font-medium text-gray-700"
            >
              Priority <span class="text-brand-700">*</span>
            </label>
            <select
              id="priority"
              v-model="form.priority"
              class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm rounded-md"
              required
            >
              <option value="" disabled>Select priority</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>
          </div>

          <!-- Discipline -->
          <div>
            <label
              for="discipline"
              class="block text-sm font-medium text-gray-700"
            >
              Discipline
            </label>
            <input
              type="text"
              id="discipline"
              v-model="form.discipline"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              placeholder="e.g., Mechanical"
            />
          </div>

          <!-- Project -->
          <div>
            <label
              for="project"
              class="block text-sm font-medium text-gray-700"
            >
              Project
            </label>
            <input
              type="text"
              id="project"
              v-model="form.project"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              placeholder="Project name"
            />
          </div>

          <!-- Additional Fields (not in your table) -->
          <!-- Question/Request -->
          <div class="md:col-span-2">
            <label
              for="question"
              class="block text-sm font-medium text-gray-700"
            >
              Question/Request <span class="text-brand-700">*</span>
            </label>
            <textarea
              id="question"
              v-model="form.question"
              rows="3"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              placeholder="Detailed description..."
              required
            ></textarea>
          </div>

          <!-- Due Date -->
          <div>
            <label
              for="dueDate"
              class="block text-sm font-medium text-gray-700"
            >
              Due Date
            </label>
            <input
              type="date"
              id="dueDate"
              v-model="form.dueDate"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
            />
          </div>

          <!-- Status -->
          <div>
            <label for="status" class="block text-sm font-medium text-gray-700">
              Status
            </label>
            <select
              id="status"
              v-model="form.status"
              class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm rounded-md"
            >
              <option value="Open">Open</option>
              <option value="In Review">In Review</option>
              <option value="Closed">Closed</option>
            </select>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="flex justify-end space-x-4 pt-6 border-t border-gray-200">
          <button
            type="button"
            @click="resetForm"
            class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-accent-gradient hover:brightness-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-500"
          >
            Submit RFI
          </button>
        </div>
      </form>
    </div>

</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const form = ref({
      subject: "",
      requestor: "",
      priority: "",
      discipline: "",
      project: "",
      question: "",
      dueDate: "",
      status: "Open",
    });

    const resetForm = () => {
      form.value = {
        subject: "",
        requestor: "",
        priority: "",
        discipline: "",
        project: "",
        question: "",
        dueDate: "",
        status: "Open",
      };
    };

    const submitForm = () => {
      console.log("Form submitted:", form.value);
      // Emit to parent: this.$emit('submit', form.value);
    };

    return {
      form,
      resetForm,
      submitForm,
    };
  },
};
</script>